const BASE_RADIUS = 4

// 기존 scale 객체 (그대로 유지!)
const scales = {
  sm: 1,
  md: 2,
  lg: 4,
  xl: 8,
}

// 함수 정의 (px 반환)
function getRadius(level = 'md') {
  const scale = scales[level] ?? 1
  return BASE_RADIUS * scale
}

// 함수형 접근과 객체형 접근 둘 다 지원
// theme.shape.radius('lg')  → 16
// theme.shape.radius.lg     → 4
const radius = Object.assign(getRadius, scales)

const shape = {
  borderRadius: BASE_RADIUS,
  radius,
}

export default shape
